import { render, staticRenderFns } from "./MessageVideo.vue?vue&type=template&id=d2b78e66&scoped=true&"
import script from "./MessageVideo.vue?vue&type=script&lang=js&"
export * from "./MessageVideo.vue?vue&type=script&lang=js&"
import style0 from "./MessageVideo.vue?vue&type=style&index=0&id=d2b78e66&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2b78e66",
  null
  
)

export default component.exports